module.exports = __webpack_public_path__ + "static/img/FigmaDDSSlicePNGe2660261ad57f4fe2e4904280742f165.e2660261.png";